module.exports = __webpack_public_path__ + "img/B62D33_E4868B_7E2D34_DD6469-256px.47f4a4e6.png";